import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createPartPallet, getPalletDetailsByBarcode, getPalletsWithDefects, updatePalletsData } from "../../aplApi/palletsHelper";
import { ReduxStatePalletEdit } from "../../types/redux/reduxStatePalletEdit";
import { initialStatePalletEdit } from "../defaultState";
import { getAplError } from "../../aplApi/exceptionHelper";
import { PalletDetail } from "../../types/palletDetail";
import { closeModalRedux, setModalError } from "./modalPallets2.feature";

export const getPalletEdit = createAsyncThunk(
    "palletEdit/getpalletDetailsBase",
    async (props: { siteId: number; sscc: string }, thunkApi) => {
        try {
            let response = await getPalletDetailsByBarcode(props.siteId, props.sscc);
            return response.data;
        } catch (error: any) {
            return thunkApi.rejectWithValue(getAplError(error, error.response.data));
        }
    }
);

export const updatePalletsDataReduxEdit = createAsyncThunk(
    "palletEdit/updatePalletsDataReduxEdit",
    async (pallets: PalletDetail[], thunkApi) => {
        try {
            await updatePalletsData(pallets);
            let updatedPallets = (await getPalletsWithDefects(pallets)).data;
            thunkApi.dispatch(closeModalRedux());
            return updatedPallets;
        } catch (error: any) {
            let aplError = getAplError(error, error.response.data);
            thunkApi.dispatch(setModalError(aplError));
            return thunkApi.rejectWithValue(getAplError(error, error.response.data));
        }
    }
);

export const createPartPalletReduxEdit = createAsyncThunk(
    "palletEdit/createPartPalletReduxEdit",
    async (pallets: PalletDetail[], thunkApi) => {
        try {
            await createPartPallet(pallets);
            let updatedPallets = (await getPalletsWithDefects(pallets)).data;
            thunkApi.dispatch(closeModalRedux());
            return updatedPallets;
        } catch (error: any) {
            let aplError = getAplError(error, error.response.data);
            thunkApi.dispatch(setModalError(aplError));
            return thunkApi.rejectWithValue(getAplError(error, error.response.data));
        }
    }
);

const palletEdit = createSlice({
    name: "palletEdit",
    initialState: initialStatePalletEdit,
    reducers: {
        onReset: function (state, action) {
            return initialStatePalletEdit;
        },
        onSetPalletDetails: function (state, action) {
            return {
                ...state,
                palletDetails: action.payload
            } as ReduxStatePalletEdit;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getPalletEdit.pending, (state, action) => {
                return {
                    ...state,
                    palletDetails: [],
                    palletDetailsLoding: true,
                    palletDetailsError: null
                } as ReduxStatePalletEdit;
            })
            .addCase(getPalletEdit.fulfilled, (state, action) => {
                return {
                    // ...state,
                    palletDetails: action.payload,
                    palletDetailsLoding: false,
                    palletDetailsFirstLoaded: true,
                    palletDetailsError: null
                } as ReduxStatePalletEdit;
            })
            .addCase(getPalletEdit.rejected, (state, action: any) => {
                return {
                    ...state,
                    palletDetails: [],
                    palletDetailsLoding: false,
                    palletDetailsError: action.payload
                } as ReduxStatePalletEdit;
            });

        builder
            .addCase(updatePalletsDataReduxEdit.pending, (state, action) => {
                return {
                    ...state,
                    palletDetailsLoding: true,
                    palletDetailsError: null
                } as ReduxStatePalletEdit;
            })
            .addCase(updatePalletsDataReduxEdit.fulfilled, (state, action) => {
                return {
                    palletDetails: action.payload,
                    palletDetailsLoding: false,
                    palletDetailsFirstLoaded: true,
                    palletDetailsError: null
                } as ReduxStatePalletEdit;
            })
            .addCase(updatePalletsDataReduxEdit.rejected, (state, action: any) => {
                return {
                    ...state,
                    palletDetailsLoding: false,
                    palletDetailsError: action.payload
                } as ReduxStatePalletEdit;
            });

        builder
            .addCase(createPartPalletReduxEdit.pending, (state, action) => {
                return {
                    ...state,
                    palletDetailsLoding: true,
                    palletDetailsError: null
                } as ReduxStatePalletEdit;
            })
            .addCase(createPartPalletReduxEdit.fulfilled, (state, action) => {
                return {
                    palletDetails: action.payload,
                    palletDetailsLoding: false,
                    palletDetailsFirstLoaded: true,
                    palletDetailsError: null
                } as ReduxStatePalletEdit;
            })
            .addCase(createPartPalletReduxEdit.rejected, (state, action: any) => {
                return {
                    ...state,
                    palletDetailsLoding: false,
                    palletDetailsError: action.payload
                } as ReduxStatePalletEdit;
            });
    }
});

export const { onReset, onSetPalletDetails } = palletEdit.actions;
export default palletEdit.reducer;
